<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.name"
          name="label"
          :counter="255"
          :label="`${$t('FORM_BUILDER.LABEL')} *`"
          :error-messages="errors.name"
          :readonly="readonly"
          :rules="getRulesByName('name')"
          @input="updateValue('name', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(el, key) in form.items" cols="12" class="pt-0">
        <v-row dense>
          <v-col cols="11">
            <v-text-field
              v-model="form.items[key].name"
              name="name"
              :counter="255"
              :label="`${$t('FORM_BUILDER.ELEMENT')} *`"
              :readonly="readonly"
              :rules="getRulesByName('name')"
              @input="updateItemsValue('name', $event, key)"
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <v-btn icon small class="mt-6" @click="removeItem(key)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { notEmpty, maxLength } from '@/modules/_global/variables/rules';

export default {
  name: 'EditLanguagesForm',

  mixins: [formEditable],

  props: {
    languageId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: {
        name: '',
        language_id: this.languageId
      },
      rules: {
        name: [notEmpty, maxLength(255)]
      }
    };
  },

  computed: {},

  methods: {
    updateItemsValue(field, v, key) {
      this.$emit('updateItem', { field: field, key: key, value: v });
    },
    removeItem(key) {
      this.$emit('removeItem', key);
    }
  }
};
</script>
